import { fetchCruiseSearchCount } from 'actions/CruiseActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect, useMemo } from 'react'

const emptyState = {
  fetching: true,
  count: 0,
}

function useCruiseSearchCount(
  params: App.OfferListFilters,
  disabled = false,
): [number, boolean] {
  const dispatch = useAppDispatch()
  const key = useMemo(() => getObjectKey(params), [params])
  const countState = useAppSelector(state => disabled ? emptyState : state.cruise.cruiseSearchCount?.[key] || emptyState)

  useEffect(() => {
    if (disabled) return
    dispatch(fetchCruiseSearchCount(params))
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled, key])

  return [countState.count, countState.fetching || false]
}

export default useCruiseSearchCount
